<template>
  <modal-v2 :show="show" :on-close="onClose" size="sm">
    <div class="px-6 pt-6 pb-4 flex flex-row items-center gap-2">
      <span class="material-symbols-outlined text-[24px] text-icon-primary">
        warning
      </span>
      <span class="text-lg leading-6 font-semibold text-primary">
        {{
          $t('INTEGRATION_SETTINGS.LIST.DISABLE_MODAL.TITLE', {
            name: integrationName,
          })
        }}
      </span>
    </div>
    <div class="px-6 text-base leading-6 text-gray-600">
      {{
        $t('INTEGRATION_SETTINGS.LIST.DISABLE_MODAL.DESC', {
          name: integrationName,
        })
      }}
    </div>
    <modal-footer-v2
      variant="warning"
      :cancel-text="$t('INTEGRATION_SETTINGS.LIST.DISABLE_MODAL.CANCEL')"
      :confirm-text="$t('INTEGRATION_SETTINGS.LIST.DISABLE_MODAL.CONFIRM')"
      :is-loading="isLoading"
      :divider="false"
      class="mt-3"
      @cancel="onClose"
      @confirm="onConfirm"
    />
  </modal-v2>
</template>

<script>
export default {
  name: 'DisableIntegrationModal',
  props: {
    show: { type: Boolean, default: false },
    integrationName: { type: String, default: '' },
    isLoading: { type: Boolean, default: false },
    onClose: { type: Function, default: () => {} },
    onConfirm: { type: Function, default: () => {} },
  },
};
</script>
